import { injectGlobal } from 'emotion/macro';
import { css } from '@emotion/core';
import regusWoff2 from '../../../assets/fonts/icons/regus-icon-font.woff2';
import regusWoff from '../../../assets/fonts/icons/regus-icon-font.woff';
import { ICON_UNICODE } from '../../../utils/constants';
import { icons } from './icon-list';

/**
 * Generates all icons styles to be added on injectGlobal.
 * @returns {Array}
 */
const generateIconStyles = () => {
  return icons.map((icon, index) => {
    const content = ICON_UNICODE + (index + 1);

    return `
      .icon-${icon}::before {
        content: "${content}";
        font-family: 'regus-icon-font';
      }
    `;
  });
};

/**
 * Injects global styles https://emotion.sh/docs/emotion#global-styles
 * https://github.hugeinc.com/HugeTechnology/IWG
 */
injectGlobal`
  @font-face {
    font-family: 'regus-icon-font';
    src: url(${regusWoff2}) format('woff2'),
         url(${regusWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  ${generateIconStyles()}
`;

/**
 * @namespace
 * Styles for Icon component.
 */
export const style = {
  display: 'inline-block',
  font: 'normal normal normal 1rem/1 "regus-icon-font"',
  speak: 'none',
  textTransform: 'none',
  MozOsxFontSmoothing: 'grayscale',
  WebkitFontSmoothing: 'antialiased',
};

export const svgicon16 = css({
  img: {
    width: '16px',
    height: '16px',
  },
});
